export default "__VITE_ASSET__913000c7__"